import React from 'react';
import MediaSelector from '../../MediaLibrary/MediaSelector';
import { Form } from 'antd';

interface FilesTabProps {
  form: any;
  isEdit?: boolean;
  getReadOnlyProps?: (type?: 'input' | 'select') => any;
}

const FilesSection: React.FC<FilesTabProps> = ({ form }) => {
  const filesValue = form.getFieldValue('files');
  const value = Array.isArray(filesValue)
    ? filesValue
    : (typeof filesValue === 'string' && filesValue
        ? filesValue.split(',').map((id: string) => parseInt(id)).filter((id: number) => !isNaN(id))
        : []);

  return (
    <Form.Item label="附件">
      <MediaSelector
        multiple
        placeholder="选择或上传文件"
        fileTypes={['image', 'document', 'video', 'audio', 'other']}
        showPreview
        value={value}
        onChange={(selectedIds?: number | number[]) => {
          const arr = Array.isArray(selectedIds) ? selectedIds : (selectedIds ? [selectedIds] : []);
          form.setFieldsValue({ files: arr });
        }}
      />
    </Form.Item>
  );
};

export default FilesSection;
